import { gql } from '@apollo/client';

const getNFTDetailsQueries = gql `
  query (
    $networkId: UUID1
    $contractAddress: String
    $onChainTokenID: BigInt
    $orgId: UUID1!
    $nftTokenId: UUID1
    $editionNumber: Int
    $ownerAddress: String
    $buyerAddress: String
  ) {
    getNFTDetails(
      networkId: $networkId
      contractAddress: $contractAddress
      onChainTokenID: $onChainTokenID
      nftTokenId: $nftTokenId
      orgId: $orgId
      editionNumber: $editionNumber
      ownerAddress: $ownerAddress
      buyerAddress: $buyerAddress
    ) {
      contractAddress
      tokenId
      network
      networkID
      owner
      contractName
      tokenType
      mintedAt
      status
      balance
      editions
      mediaSourceExtension
      mediaSourceType
      mediaSourceURL
      price {
        buyNowPrice {
          value
          unit
          type
        }
        lastPurchasedPrice {
          value
          unit
          type
        }
        makeOfferHighestPrice {
          value
          unit
          type
        }
        makeOfferLatestPrice {
          value
          unit
          type
        }
      }
      latestOffer {
        price {
          value
          unit
          type
        }
      }
      tokenURI
      editionNumber
      isFavorite
      nftTokenId
      tokenOwnerAvatar
      tokenOwnerAddress
      tokenOwnerUsername
      isBuyNowEnabled
      isMakeOfferEnabled
      isOfferExist
      listedOrderInfo {
        id
        listedCurrency {
          contractAddress
        }
        price {
          value
          unit
          type
        }
      }
      artist {
        id
        description
        artistName
        artistLocation
        artistContactEmail
        artistContactNumber
        artistWebsite
        slug
      }
      metadata {
        name
        description
        image
        animationURL
        openSeaImageURL
        tags
        yearCreated
        createdBy
        attributes {
          traitType
          displayType
          maxValue
          value {
            __typename
            ... on AttributeValueString {
              stringValue
            }
            ... on AttributeValueInt {
              intValue
            }
            ... on AttributeValueFloat {
              floatValue
            }
          }
        }
      }
    }
  }
`;
const getNFTHistoryQueries = gql `
  query (
    $networkId: String!
    $contractAddress: String!
    $tokenId: BigInt!
    $nftTokenId: UUID1
    $filterBy: NFTTxEventType
    $orgId: UUID1!
    $ownerAddress: String
    $limit: Int
    $offset: Int
  ) {
    getNFTHistoryV2(
      networkId: $networkId
      contractAddress: $contractAddress
      tokenId: $tokenId
      nftTokenId: $nftTokenId
      filterBy: $filterBy
      orgId: $orgId
      ownerAddress: $ownerAddress
      offset: $offset
      limit: $limit
    ) {
      totalCount
      data {
        blockNum
        hash
        from
        to
        value
        tokenId
        category
        asset
        price {
          value
          unit
          type
        }
        blockTimestamp
        eventType
        fromUserAvatar
        fromUserName
        toUserAvatar
        toUserName
        erc1155Metadata {
          tokenId
          value
        }
      }
    }
  }
`;
const getNFTAttributesRarityQueries = gql `
  query (
    $contractAddress: String!
    $tokenID: BigInt!
    $networkID: UUID1!
    $refreshCatch: Boolean
  ) {
    getNFTAttributesRarity(
      contractAddress: $contractAddress
      tokenID: $tokenID
      networkID: $networkID
      refreshCatch: $refreshCatch
    ) {
      traitType
      value {
        __typename
        ... on AttributeValueString {
          stringValue
        }
        ... on AttributeValueInt {
          intValue
        }
        ... on AttributeValueFloat {
          floatValue
        }
        ... on AttributeValueBool {
          boolValue
        }
      }
      displayType
      maxValue
      prevalance
    }
  }
`;

export { getNFTAttributesRarityQueries, getNFTDetailsQueries, getNFTHistoryQueries };
